export default __webpack_public_path__ + "static/media/0156.9a55c7be.jpg";